var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-tooltip"},[_c('span',{staticClass:"tooltip rounded shadow-lg p-1 bg-white border border-teal -mt-8"},[_vm._v(_vm._s(_vm.message))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }